import { newColors } from "constants/newColors";

import styled, { css } from "styled-components";
import { Edit } from "@styled-icons/boxicons-solid/Edit";
import { ExternalLinkOutline } from "@styled-icons/evaicons-outline/ExternalLinkOutline";
import { ManageAccounts } from "@styled-icons/material/ManageAccounts";
import { NavigateBefore } from "@styled-icons/material/NavigateBefore";
import { Import } from "@styled-icons/boxicons-regular/Import";
import { Upload } from "@styled-icons/boxicons-regular/Upload";
import { Report } from "@styled-icons/boxicons-solid/Report";
import { FileExcel } from "@styled-icons/remix-line/FileExcel";
import { CardList } from "@styled-icons/bootstrap/CardList";
import { MailOutline } from "@styled-icons/material/MailOutline";
import {
  ButtonProps,
  ButtonSizes,
  createButtonStyleBySize,
  createButtonStyleByVariantTypes,
} from "components/parts/Button/Button/styled";

const createIconButtonStyleBySize = (size?: ButtonSizes) => {
  switch (size) {
    case "small":
      return css`
        font-size: 3.3px;
      `;
    case "medium":
      return css`
        font-size: 4.3px;
      `;
    case "large":
      return css`
        font-size: 5px;
      `;
    case "xlarge":
      return css`
        font-size: 8px;
      `;
  }
};

export const StyledEdit = styled(Edit)``;

export const StyledExternalLinkOutline = styled(ExternalLinkOutline)``;

export const StyledManageAccounts = styled(ManageAccounts)``;

export const StyledNavigateBefore = styled(NavigateBefore)``;

export const StyledImport = styled(Import)``;

export const StyledReport = styled(Report)``;

export const StyledFileExcel = styled(FileExcel)``;

export const StyledUpload = styled(Upload)``;

export const StyledCardList = styled(CardList)``;

export const StyledMailOutline = styled(MailOutline)``;

export const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledTextWithIconButton = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  border: 1px solid;
  border-color: ${newColors.border};
  border-radius: 50px;
  padding: 0.4em 2em 0.4em 1.7em;
  box-sizing: border-box;
  white-space: nowrap;
  font-weight: bold;
  height: min-content;
  color: ${newColors.text};
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
  :disabled {
    cursor: default;
    opacity: 0.3;
  }

  ${({ variant }) => {
    return createButtonStyleByVariantTypes(variant);
  }}
  /*  FIX ME */
  ${({ variant }) =>
    variant === "primary-reverse" &&
    css`
      border: solid 1px ${newColors.primary};
    `}

  ${({ size }) => {
    return createButtonStyleBySize(size);
  }}
`;

export const StyledIcon = styled.div<ButtonProps>`
  display: flex;
  ${({ size }) => createIconButtonStyleBySize(size)}
  ${({ variant }) => createButtonStyleByVariantTypes(variant)}
 border: none;

  svg {
    ${({ variant }) => createButtonStyleByVariantTypes(variant)}
    height: 3.5em;
    padding: 0;
    margin-right: 0.5em;
  }
`;

export const StyledText = styled.span``;
